<template>
  <div class="sgc-chips-wrap">
    <div class="sgc-chips-ctr">
      <v-chip
        v-for="item in props.modelValue"
        :key="item"
        class="autocmp-chip"
        size="small"
        :disabled="props.disabled"
        closable
        @click:close="removeItem(item)"
      >
        {{ item }}
      </v-chip>
    </div>
    <v-autocomplete
      v-bind="$attrs"
      variant="outlined"
      density="compact"
      persistentPlaceholder
      hideNoData
      validateOn="input"
      height="32px"
      :hideDetails="!hasDetails"
      :items="[...items, ...(tmpSearch && !items?.includes(tmpSearch) ? [tmpSearch] : [])]"
      bgColor="#ffffff"
      :disabled="props.disabled"
      :values="''"
      :placeholder="props.placeholder"
      :search="tmpSearch"
      :modelValue="tmpModelValue"
      :autofocus="props.autofocus"
      @update:search="onSearch"
      @keydown.tab="e => addItem(tmpSearch, e)"
      @keydown.enter="e => addItem(tmpSearch, e)"
      @update:modelValue="addItem"
    />
  </div>
</template>

<script setup>
import { computed, nextTick, ref, useAttrs } from "vue";

defineOptions({ inheritAttrs: false });

const props = defineProps({
  modelValue: { type: Array, default: () => [] },
  disabled: { type: Boolean, default: false },
  placeholder: { type: String, default: "Add item" },
  autofocus: { type: Boolean, default: true },
  items: { type: Array, default: () => [] },
});
const emit = defineEmits(["update:modelValue", "update:hasError"]);
const attrs = useAttrs();
const tmpSearch = ref("");
const tmpModelValue = ref("");

const normalizedRules = computed(() =>
  Array.isArray(attrs.rules) ? attrs.rules : typeof attrs.rules === "function" ? [attrs.rules] : [],
);

const hasDetails = computed(() => normalizedRules.value.length > 0 || !!attrs.hint);

const runRules = value => {
  for (const rule of normalizedRules.value) {
    const result = rule(value);
    if (result !== true) return result;
  }
  return null;
};

const onSearch = search => {
  tmpSearch.value = search;
  const value = search?.trim?.() ?? "";
  const error = value ? runRules(value) : null;
  emit("update:hasError", error !== null);
};

const addItem = (item, event) => {
  const trimmed = item?.trim?.() ?? "";
  if (trimmed) {
    const error = runRules(trimmed);
    if (error !== null) {
      event?.preventDefault();
      emit("update:hasError", true);
      nextTick(() => {
        tmpSearch.value = item;
        tmpModelValue.value = item;
      });
      return;
    }
    if (!props.modelValue.includes(trimmed)) {
      event?.preventDefault();
      emit("update:modelValue", [...props.modelValue, trimmed]);
    }
  }
  emit("update:hasError", false);
  nextTick(() => {
    tmpSearch.value = "";
    tmpModelValue.value = "";
  });
};

const removeItem = item => {
  emit(
    "update:modelValue",
    props.modelValue.filter(i => i !== item),
  );
};
</script>
